import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { SECTIONS } from '../../config/sections';
import { useLanguage } from '../../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import '../static/Navbar.css'
const Logo = require('../images/BCCC_logo.png');

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
    const aboutDropdownRef = useRef(null);
    const { t } = useLanguage();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
        setAboutDropdownOpen(false);
    };

    const toggleAboutDropdown = () => {
        setAboutDropdownOpen(!aboutDropdownOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (aboutDropdownRef.current && !aboutDropdownRef.current.contains(event.target)) {
                setAboutDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container">
                <div className="navbar-logo">
                    <Link
                        to="/"
                        onClick={() => {
                            closeMenu();
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                    >
                        <img src={Logo} alt="BCCC Logo"/>
                    </Link>
                </div>

                <div className="navbar-right">
                    <div id="mobile-menu" className={`navbar-menu ${isOpen ? 'show' : ''}`}>
                        {/* About Dropdown */}
                        <div
                            className="nav-dropdown"
                            ref={aboutDropdownRef}
                            onMouseEnter={() => window.innerWidth >= 992 && setAboutDropdownOpen(true)}
                            onMouseLeave={() => window.innerWidth >= 992 && setAboutDropdownOpen(false)}
                        >
                            <button
                                className={`nav-link dropdown-trigger ${aboutDropdownOpen ? 'active' : ''}`}
                                onClick={toggleAboutDropdown}
                                aria-expanded={aboutDropdownOpen}
                            >
                                {t('nav.about')}
                                <i className={`fas fa-chevron-down dropdown-icon ${aboutDropdownOpen ? 'rotate' : ''}`}></i>
                            </button>
                            <div className={`dropdown-menu ${aboutDropdownOpen ? 'show' : ''}`}>
                                <HashLink
                                    smooth
                                    to="/statement-of-faith"
                                    className="dropdown-item"
                                    onClick={closeMenu}
                                >
                                    {t('nav.beliefs')}
                                </HashLink>
                                <HashLink
                                    smooth
                                    to="/team"
                                    className="dropdown-item"
                                    onClick={closeMenu}
                                >
                                    {t('nav.leaders')}
                                </HashLink>
                                <HashLink
                                    smooth
                                    to="/fellowships"
                                    className="dropdown-item"
                                    onClick={closeMenu}
                                >
                                    {t('nav.fellowships')}
                                </HashLink>
                                <Link
                                    to="/sbi"
                                    className="dropdown-item"
                                    onClick={closeMenu}
                                >
                                    {t('nav.anthology')}
                                </Link>
                            </div>
                        </div>

                        <HashLink
                            smooth
                            to={`/#${SECTIONS.SERVICE}`}
                            className="nav-link"
                            onClick={closeMenu}
                        >
                            {t('nav.service')}
                        </HashLink>

                        <HashLink
                            smooth
                            to={`/#${SECTIONS.FOOTER}`}
                            className="nav-link"
                            onClick={closeMenu}
                        >
                            {t('nav.contact')}
                        </HashLink>
                    </div>

                    <div className="navbar-actions">
                        <LanguageSwitcher />
                        <button
                            className="navbar-toggler"
                            type="button"
                            onClick={toggleMenu}
                            aria-label="Toggle navigation menu"
                            aria-expanded={isOpen}
                            aria-controls="mobile-menu"
                        >
                            <span className="toggler-bar"></span>
                            <span className="toggler-bar"></span>
                            <span className="toggler-bar"></span>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default NavBar;
